module.exports = __webpack_public_path__ + "img/cloud1.c8249a9e.png";